import {HarlequinSoundConfig} from "../HarlequinSoundConfig";
import {HarlequinGameModuleConfig} from "../HarlequinGameModuleConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {HarlequinParsedGameData} from "../server/data/HarlequinParsedGameData";
import {GameModeTransitionController} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionController";
import {HarlequinBackground} from "../background/HarlequinBackground";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {Timeline, TimelineLite} from "gsap";

export class RespinTransitionController extends GameModeTransitionController {

    private _reverse:boolean = false;
    private _scattersCollected:number;
    private _wildOverlayReels:boolean [];
    private _restore:boolean;
    //private _toMode:string;

    constructor(fromMode:string, toMode:string, reverse:boolean = false) {
        super(fromMode, toMode);
        this._reverse = reverse;
    }

    protected onGameDataParsed(data: ParsedServerData): void {
        super.onGameDataParsed(data);

        this._wildOverlayReels = (<HarlequinParsedGameData> data).wildOverlayReels || [false, false, false, false, false];
        this._restore = (<any> data).isRestoreState;
    }

    public start():void {
        const tl:Timeline = new TimelineLite();

        HarlequinGameModuleConfig.CURRENT_MODE = this._toMode;

        this._scattersCollected = (<HarlequinParsedGameData> this._serverData).scattersCollected;

        if(this._reverse) {
            SlotGame.sound.fadeAmbience(0, 50);

            if(this._toMode === "FREESPIN") {
                (<HarlequinBackground> HarlequinGameModuleConfig.background).playBgSpine("bonusGame");
                //SlotGame.sound.playAmbience(HarlequinSoundConfig.instance.FREESPIN_AMBIANCE);
            } else {
                (<HarlequinBackground> HarlequinGameModuleConfig.background).playBgSpine("basegame");
                if(this._fromMode !== "FREESPIN" && this._fromMode !== "WILD_RESPIN_FS") {
                    console.log("SWITCHING AMB WITHOUT FADE");
                    SlotGame.sound.playAmbience(HarlequinSoundConfig.instance.MAIN_GAME_AMBIANCE);
                }
            }

            //if(!(this._toMode === "NORMAL" && (this._fromMode === "FREESPIN" || this._fromMode === "WILD_RESPIN_FS"))) {
                //console.log("RESPIN TRANSITION FADE AMB");
                SlotGame.sound.fadeAmbience(1, 50);
            //}
        }
        else {
            if((this._fromMode === "NORMAL" && this._toMode === "WILD_RESPIN" || this._fromMode === "FREESPIN" && this._toMode === "WILD_RESPIN_FS")) {

                let numberLeft:number = 0;

                this._wildOverlayReels.forEach((evalVal:boolean, index:number) => {
                    if(evalVal) {
                        numberLeft = index;
                    }
                });

                if(this._restore && (this._toMode === "WILD_RESPIN" || this._toMode === "WILD_RESPIN_FS")) {
                    if(this._serverData.totalWin > 0) {
                        SlotGame.winFieldController.showWinField(undefined, undefined, true);
                    }
                }

                tl.add(() => {

                    // TODO: This is left sign!
                    HarlequinGameModuleConfig.harlequinSignView.playTextSpine(undefined, numberLeft, undefined, false, undefined, true);

                    // TODO: shifting keypad number sanity
                    if (this._toMode !== "WILD_RESPIN_FS") {
                        SlotGame.keypad.setZeroBetSpinCounter(numberLeft);
                        HarlequinGameModuleConfig.harlequinSignView.setRespinSignAnimation((numberLeft <= 0) ? -1 : numberLeft);
                    }
                    SlotGame.sound.playEffect(HarlequinSoundConfig.instance.RESPIN_INTRO);
                    SlotGame.sound.fadeAmbience(0, 50);
                    SlotGame.sound.playAmbience(HarlequinSoundConfig.instance.RESPIN_AMBIANCE);
                    SlotGame.sound.fadeAmbience(1, 50);


                    if(this._scattersCollected < 1 && this._toMode !== "WILD_RESPIN_FS") {
                        HarlequinGameModuleConfig.harlequinSignView.playMiddleBar("New3HeadsDefault", 0, false);
                    }

                    if(this._restore && (this._toMode === "WILD_RESPIN" || this._toMode === "WILD_RESPIN_FS")) {
                        HarlequinGameModuleConfig.harlequinSignView.playSignSpine("baseGameToRespin", undefined, undefined, undefined, numberLeft - 1, true);
                        HarlequinGameModuleConfig.harlequinSignView.playMiddleBar("New3HeadsDefault", 0, false)
                    }
                    else {
                        HarlequinGameModuleConfig.harlequinSignView.playSignSpine("baseGameToRespin", undefined, undefined, undefined, numberLeft - 1);
                    }

                    HarlequinGameModuleConfig.harlequinSignView.enterMode(this._fromMode, this._toMode);

                    (<HarlequinBackground> HarlequinGameModuleConfig.background).playBgSpine("respin");
                }, (this._scattersCollected < 1)? "+=1.5" : "+=1.5");

                tl.add(() => {}, "+=1.5");
            }
        }

        tl.add(() => {
            super.start();
        });
    }


}